// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Committee } from './committee';
import { CommitteeAttachmentReview } from './committee-attachment-review';
import { Proposal } from './proposal';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CommitteeAttachment extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static Types = {
        Document: 1,
        Minutes: 2,
        Agenda: 3,
    };

    get typeName() {
        return this.typeId === 1 ? 'Document' : 'Minutes'
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  agendaText?: string;
  assignedMonth?: Date;
  committeeId?: number;
  created?: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  filename?: string;
  name?: string;
  proposalId?: number;
  typeId!: number;
  committee!: Committee;
  committeeAttachmentReviews!: CommitteeAttachmentReview[];
  proposal!: Proposal;
}

